import * as Configuration from './configuration'
import * as Constants from './constants'
import * as Forms from '@rushplay/forms'
import * as Payments from './payments'
import * as React from 'react'
import * as ReactRedux from 'react-redux'
import * as Reselect from 'reselect'
import * as ThemeUi from 'theme-ui'

import PropTypes from 'prop-types'

// eslint-disable-next-line no-unused-vars
export function PraxisProcessing(props) {
  const [iframeSrc, setIframeSrc] = React.useState(null)

  // prettier-ignore
  const amountCents = Forms.useField('#/properties/amount', {noRegister: true}).value
  const apiUrl = ReactRedux.useSelector(Configuration.getApiUrl)
  const getPlayerData = Reselect.createStructuredSelector({
    sessionToken: Configuration.getToken,
  })
  const playerData = ReactRedux.useSelector(getPlayerData)
  const {transactionType} = Payments.useTransactionContext()

  React.useEffect(() => {
    function messageReceive(event) {
      if (event.key == 'praxisMessage') {
        const message = JSON.parse(event.newValue)

        switch (message.status) {
          case 'approved':
            props.onStepChange(Constants.TransactionStep.Success)
            break

          case 'initialized':
          case 'pending':
            props.onStepChange(Constants.TransactionStep.Processing)
            break

          default:
            props.onStepChange(Constants.TransactionStep.Failure)
        }

        localStorage.removeItem('praxisMessage')
      }
    }

    window.addEventListener('storage', messageReceive)

    return () => window.removeEventListener('storage', messageReceive)
  })

  React.useEffect(() => {
    const cashierJson = {
      amount_cents: amountCents,
      transaction_type: transactionType,
    }

    fetch(`${apiUrl}/praxis/cashier`, {
      method: 'POST',
      headers: {
        'Accept': 'application/vnd.casinosaga.v1, application/json',
        'Authorization': playerData.sessionToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cashierJson),
    })
      .then((response) => response.json())
      .then((data) => {
        setIframeSrc(data.redirect_url)
      })
  }, [])

  if (!iframeSrc) {
    return (
      <React.Fragment>
        <ThemeUi.Flex sx={{justifyContent: 'center'}}>
          <ThemeUi.Spinner />
        </ThemeUi.Flex>
      </React.Fragment>
    )
  }

  return (
    <ThemeUi.Flex
      sx={{
        'alignItems': 'center',
        'justifyContent': 'center',
        'flexDirection': 'column',
        'height': '100%',
        '#praxis-payment-system': {
          height: '100%',
          width: '100%',
          maxWidth: '600px',
        },
      }}
    >
      <iframe
        src={iframeSrc}
        sandbox="allow-forms allow-modals allow-orientation-lock allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts"
        style={{border: 'none'}}
      />
    </ThemeUi.Flex>
  )
}

PraxisProcessing.propTypes = {
  onStepChange: PropTypes.func.isRequired,
}
